import { IMovementPlan } from "@/store/apis/worldMapAPI/worldMap.types"

export type TPlanWriteKind = "replace" | "step" | "rest" | "cancel"

// The SINGLE writer for the getMovementState cache. Returns the plan to store
// (possibly the unchanged `cached` when the incoming write is stale).
export const applyPlanWrite = (
  cached: IMovementPlan | null,
  incoming: IMovementPlan,
  kind: TPlanWriteKind
): IMovementPlan => {
  if (!cached) return incoming

  if (kind === "cancel") {
    return { ...cached, cancelAfterCurrentStep: true }
  }
  if (kind === "rest") {
    return incoming.startedAtMs > cached.startedAtMs ? incoming : cached
  }
  // replace (started/rerouted) and step are ordered by occurredAt.
  return incoming.lastAppliedOccurredAt > cached.lastAppliedOccurredAt
    ? incoming
    : cached
}
